<template>
    <div ref="salesAnalysisWeeklyChart" style="min-height: 400px;" v-if="data != null"></div>
    <div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
        <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data () {
            return {
                chart : null,
            }
        },
        props : ['data'],
        mounted () {
            this.createChart();
            this.getData();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            getData () {
                let length = this.chart.data.length;

                let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                let data = [];
                if (this.data != null && this.data.length > 0) {
                    for (var i in this.data) {
                        data.push({
                            "month" : monthNames[this.data[i].month-1],
                            "Day 1-7" : this.data[i]["1-7Sales"],
                            "Day 8-14" :this.data[i]["8-14Sales"],
                            "Day 15-21" : this.data[i]["14-21Sales"],
                            "Day 21+" : this.data[i]["21-31Sales"]
                        })
                    }
                } else {
                    data.push({
                        "month" : "No Data",
                        "Day 1-7" : 0,
                        "Day 8-14" :0,
                        "Day 15-21" : 0,
                        "Day 21+" : 0
                    })
                }

                this.chart.addData(data, length);
            },
            createChart () {

                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                this.chart = am4core.create(this.$refs.salesAnalysisWeeklyChart, am4charts.XYChart)
                this.chart.colors.step = 2;

                this.chart.legend = new am4charts.Legend()
                this.chart.legend.position = 'bottom'
                this.chart.legend.paddingBottom = 20
                this.chart.legend.labels.template.maxWidth = 95

                let xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
                xAxis.dataFields.category = 'month'
                xAxis.renderer.cellStartLocation = 0.1
                xAxis.renderer.cellEndLocation = 0.9
                xAxis.renderer.grid.template.location = 0;
                xAxis.title.text = 'Month / Week Number';

                let yAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                yAxis.min = 0;
                yAxis.title.text="No. of Sales / Sales Target";

                this.chart.cursor = new am4charts.XYCursor();

                // this.chart.data = [
                //     {
                //         month: 'Place #1',
                //         "Day 1-7": 40,
                //         "Day 8-14": 55,
                //         "Day 15-21": 60,
                //         "Day 21+": 20
                //     },
                //     {
                //         month: 'Place #2',
                //         "Day 1-7": 30,
                //         "Day 8-14": 78,
                //         "Day 15-21": 69,
                //         "Day 21+": 20
                //     },
                //     {
                //         month: 'Place #3',
                //         "Day 1-7": 27,
                //         "Day 8-14": 40,
                //         "Day 15-21": 45,
                //         "Day 21+": 20
                //     },
                //     {
                //         month: 'Place #4',
                //         "Day 1-7": 50,
                //         "Day 8-14": 33,
                //         "Day 15-21": 22,
                //         "Day 21+": 20
                //     }
                // ]

                this.createSeries("Day 1-7", 'Week 1');
                this.createSeries("Day 8-14", 'Week 2');
                this.createSeries("Day 15-21", 'Week 3');
                this.createSeries("Day 21+", 'Week 4');

            },
            createSeries(value, name) {
                let series = this.chart.series.push(new am4charts.ColumnSeries())
                series.dataFields.valueY = value
                series.dataFields.categoryX = 'month'
                series.name = name
                // series.columns.template.tooltipText = "[#fff font-size: 15px]{tooltipName} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
                series.columns.template.adapter.add('tooltipText', function(text, target){
                    return "[#fff font-size: 15px]{name}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]";
                })

                let bullet = series.bullets.push(new am4charts.LabelBullet())
                bullet.interactionsEnabled = false
                bullet.dy = 30;
                bullet.label.text = '{valueY}'
                bullet.label.fill = am4core.color('#ffffff')

                return series;
            }
        }
    }
</script>

<style scoped>

</style>